import React from "react";
import "./errorCard.sass";
import logo from "../../../assets/images/myRymanHomeLogo.svg";

export interface IErrorCardProps {
  title?: string;
  error: string;
  resolution: string;
}
const logoWidth = 87;

const ErrorCard: React.FC<IErrorCardProps> = ({
  title,
  error,
  resolution,
  children
}) => {
  return (
    <div className="error-card">
      <img src={logo} alt="Logo" width={logoWidth} />
      <div>
        <div>
          {title && <div className="error-header">{title}</div>}
          <div className="error-detail">
            <div>{error}</div>
            <hr />
            <div>{resolution}</div>
          </div>
          {children && <div className="error-content">{children}</div>}
        </div>
      </div>
    </div>
  );
};

export default ErrorCard;
